import React from "react";
import { styled, keyframes } from "@mui/material/styles";
import { PanelResizeHandle as BasePanelResizeHandle } from "react-resizable-panels";

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
`;

const StyledPanelResizeHandle = styled(BasePanelResizeHandle, {
  shouldForwardProp: (prop) => prop !== "direction",
})(({ direction = "vertical" }) => {
  const isVertical = direction === "vertical";
  return {
    ...(isVertical
      ? {
          width: "6px",
          height: "100%",
          cursor: "col-resize",
        }
      : {
          height: "6px",
          width: "100%",
          cursor: "row-resize",
        }),

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f2f2f2",

    "&:hover": {
      backgroundColor: "#e6e6e6",

      "& .grip-bar": {
        animation: `${pulse} 0.6s ease-in-out infinite`,
      },
    },

    "&:active": {
      transform: "scale(1)",
    },

    "& .grip-container": {
      display: "flex",
      flexDirection: isVertical ? "column" : "row",
      gap: "5px",
      alignItems: "center",
      justifyContent: "center",
    },

    "& .grip-bar": {
      background: "#999999",
      borderRadius: "4px",
      boxShadow: "0 0 4px rgba(0, 0, 0, 0.4)",
      transition:
        "transform 0.2s ease, background 0.3s ease, box-shadow 0.2s ease",
      ...(isVertical
        ? {
            width: "5px",
            height: "35px",
          }
        : {
            width: "35px",
            height: "5px",
          }),
    },

    "&:hover .grip-bar": {
      background: "linear-gradient(145deg, #000, #444)",
      transform: "scale(1.1)",
      boxShadow: "0 0 6px rgba(0, 0, 0, 0.6)",
    },

    "&:active .grip-bar": {
      transform: "scale(0.95)",
      boxShadow: "inset 0 1px 3px rgba(0, 0, 0, 0.3)",
    },
  };
});

const CustomResizeHandle = ({ direction = "vertical", ...rest }) => {
  return (
    <StyledPanelResizeHandle direction={direction} {...rest}>
      <div className="grip-container">
        <div className="grip-bar" />
      </div>
    </StyledPanelResizeHandle>
  );
};

export default CustomResizeHandle;
